<template>
    <div class="navDiv1" id="topheader1" :key="$route.path">
            <nav class="navbar navbar-expand-md navbar-light MobileHide gamesNav1">
              <button class="navbar-toggler" type="button" style="margin-bottom: 5px; border: none;" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse" id="navbarNav" v-if="ssize < 1000">
                <ul class="" style="color: black; list-style-type: none; font-size: 13px;">
                  <li><router-link id="routerLink1" to="/Live">{{ $t('LanguageEn.tabLive') }}</router-link> </li>
                  <li><router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate4() }}">{{date1}}</router-link></li>
                  <li><router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate2() }}">{{date2}}</router-link></li>
                  <li><router-link id="routerLink1" to="/Today">{{ $t('LanguageEn.tabToday') }}</router-link></li>
                  <li><router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate1() }}">{{date3}}</router-link></li>
                  <li><router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate3() }}">{{date4}}</router-link></li>
                  <li>
                  <div style="margin-left: auto;  border: none; color: white !important; height: 40px; width: 60px;" v-on:click="dateIden = value ,setLIDs(), redirect()">
                  <b-form-datepicker button-only selected-variant="success" button-variant="none" today-variant="success"  placeholder="Today" id="example-datepicker" right size="md" v-model="value" class="mb-2" style="border: none;  background: none; margin-left: 7px;  border-radius: 0px;"></b-form-datepicker>
                  </div>
                  </li>
                </ul>
              </div>

              <div class="collapse navbar-collapse" id="navbarNav1">
                <ul class="navbar-nav" style="margin-left: 7px;">
                  <li class="nav-item ">
                    <router-link  style="border-top-left-radius: 5px;" id="routerLink1" to="/Live">{{ $t('LanguageEn.tabLive') }}</router-link> 
                  </li>
                   <li class="nav-item MobileMiddle"  v-if="ssize > 991">
                    <router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate4() }}">{{date1}}</router-link> 
                  </li>
                   <li class="nav-item ">
                    <router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate2() }}">{{date2}}</router-link> 
                  </li>
                  <li class="nav-item ">
                    <router-link class="active" id="routerLink1" to="/Today">{{ $t('LanguageEn.tabToday') }}</router-link> 
                  </li>
                   <li class="nav-item ">
                    <router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate1() }}">{{date3}}</router-link> 
                  </li>
                   <li class="nav-item MobileMiddle" v-if="ssize > 991">
                    <router-link id="routerLink1" :to="{ name: 'Finished', params: { dateS: getDate3() }}">{{date4}}</router-link> 
                  </li>
                  <li class="nav-item " v-if="cookiesObject.token">
                    <router-link id="routerLink1" to="/MyGames" style="font-size: 10.5px;">{{ $t('LanguageEn.tabMyGames') }}</router-link> 
                  </li>
                  <li class="nav-item " v-else>
                    <div id="routerLink1" to="/MyGames" style="font-size: 10.5px; cursor: pointer;" data-toggle="modal" data-target="#exampleModal">{{ $t('LanguageEn.tabMyGames') }}</div> 
                  </li>
                  <li>
                  <div style="margin-left: auto; background-image: linear-gradient(#39b44a , #1b5f20); border-top-right-radius: 5px; border: none; color: white !important; height: 40px; width: 60px;" v-on:click="dateIden = value ,setLIDs(), redirect()">
                  <b-form-datepicker button-only selected-variant="success" button-variant="success" today-variant="success"  placeholder="Today" id="example-datepicker" right size="md" v-model="value" class="mb-2" style="border: none;  background: none; margin-left: 7px;  border-radius: 0px;"></b-form-datepicker>
                  </div>
                  </li>

                </ul>
              </div>
            </nav>
            <div style="color: black;">
              <router-view />
            </div>
          </div>
</template>

<script>
import { mapActions } from "vuex";
import {mapGetters} from 'vuex';

export default {
  name: 'NavbarLinks',
  data(){
    return{
      date1: '',
      date2: '',
      date3: '',
      date4: '',
      value: '',
      ssize: '',
      cookiesObject: '',
    }
  },

  mounted(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    window.addEventListener('resize', this.nowSize);
    this.nowSize();
  },

  destroyed(){
      window.removeEventListener('resize', this.nowSize);
  },


  methods:{
    ...mapActions(['setdateNtime']),
     setLIDs(){
            this.setdateNtime(this.dateIden);
        },
         nowSize(){
        this.ssize = window.innerWidth;
      },
        redirect(){
          if (this.value != undefined) 
          {
           this.$router.push({ name: 'Finished', params: { dateS: this.value } })         
          }
        },
    getDate1(){
        var dt = new Date();
        dt.setDate( dt.getDate() + 1 );
        var fdDate = dt.getDate();
        var fdMonth =(dt.getMonth() + 1);
        var fdYear = dt.getFullYear();   

        this.date3 = this.monthNames[fdMonth - 1] + ' ' + dt.getDate();

        if (fdMonth.toString().length == 1) {
                  fdMonth = '0' + fdMonth; 
                } 
                if (fdDate.toString().length == 1) {
                  fdDate = '0' + fdDate; 
                } 
         
        var fd =  fdYear + '-' + fdMonth + '-' +fdDate;
        return fd;
    },   
    getDate3(){
        var dt = new Date();
        dt.setDate( dt.getDate() + 2 );
        var fdDate = dt.getDate();
        var fdMonth =(dt.getMonth() + 1);
        var fdYear = dt.getFullYear();   

        this.date4 = this.monthNames[fdMonth - 1] + ' ' + dt.getDate();

        if (fdMonth.toString().length == 1) {
                  fdMonth = '0' + fdMonth; 
                } 
                if (fdDate.toString().length == 1) {
                  fdDate = '0' + fdDate; 
                } 
         
        var fd =  fdYear + '-' + fdMonth + '-' +fdDate;
        return fd;
    },   
    getDate2(){
        var dt = new Date();
        dt.setDate( dt.getDate() - 1 );
        var fdDate = dt.getDate();
        var fdMonth =(dt.getMonth() + 1);
        var fdYear = dt.getFullYear();   

        this.date2 = this.monthNames[fdMonth - 1] + ' ' + dt.getDate();

        if (fdMonth.toString().length == 1) {
                  fdMonth = '0' + fdMonth; 
                } 
                if (fdDate.toString().length == 1) {
                  fdDate = '0' + fdDate; 
                } 
         
        var fd =  fdYear + '-' + fdMonth + '-' +fdDate;
        return fd;
    },
    getDate4(){
        var dt = new Date();
        dt.setDate( dt.getDate() - 2 );
        var fdDate = dt.getDate();
        var fdMonth =(dt.getMonth() + 1);
        var fdYear = dt.getFullYear();   

        this.date1 = this.monthNames[fdMonth - 1] + ' ' + dt.getDate();

        if (fdMonth.toString().length == 1) {
                  fdMonth = '0' + fdMonth; 
                } 
                if (fdDate.toString().length == 1) {
                  fdDate = '0' + fdDate; 
                } 
         
        var fd =  fdYear + '-' + fdMonth + '-' +fdDate;

        return fd;
    },      
  },
  
  props: {
  },

  computed: {
   ...mapGetters(['dateNtime']),
    monthNames(){
       return [this.$t('LanguageEn.month1'), this.$t('LanguageEn.month2'), this.$t('LanguageEn.month3'), this.$t('LanguageEn.month4'), this.$t('LanguageEn.month5'), this.$t('LanguageEn.month6'),this.$t('LanguageEn.month7'), this.$t('LanguageEn.month8'), this.$t('LanguageEn.month9'), this.$t('LanguageEn.month10'), this.$t('LanguageEn.month11'), this.$t('LanguageEn.month12')]
    },
  },
}
</script>

<style scoped>
.navDiv1{
    width: 100%;
    height: auto;
    color: white;
    background: #f9f9f9;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.nav-item{
    font-size: small;
    
}
.nav-link{
    height: 40px;
    color: green !important;
    text-align: center;
}

.leftEst{
    margin-left: 5px;
}

#routerLink1{
  padding-top: 10%;
    padding-left: 0px !important;
    display: inline-block; 
    text-decoration: none;
    width: 80px ;
    height: 40px !important;
    color: green;
    text-align: center !important;
    font-weight: 550;
}
#routerLink1 .navbar-nav li > a {
	text-transform: capitalize;
	transition: background-color 0.2s, color 0.2s;
}

    #routerLink1 .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #1b5f20);
		color: #fff;
    font-weight: 550;
	}

#routerLink1 .navbar-nav li.active > a.active {
	background-color: red;
	color: white;
}
.router-link-active{
    background-image: linear-gradient(#39b44a , #1b5f20);
    color: white !important;
}


/* Navbar link underline */

.gamesNav1{
    background: white !important;
    border-bottom: 10px solid #1b5e20;
    padding: 0 !important;
    padding-top: 10px !important;
    margin-bottom: 5px !important;
    width: 100%;
    /* margin-left: 6px; */
}

#topheader1 .navbar-nav li > a {
	text-transform: capitalize;
	transition: background-color 0.2s, color 0.2s;
}

    #topheader1 .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #1b5f20);
		color: #fff !important;
	}

#topheader1 .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}

@media only screen and (max-width: 600px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 600px) {
  .MobileShow {
    display: none;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1200px) {
  #routerLink1{
  padding-top: 10%;
    padding-left: 0px !important;
    display: inline-block; 
    text-decoration: none;
    width: 64px ;
    height: 40px !important;
    color: green;
    text-align: center !important;
    font-weight: 550;
}
.gamesNav1{
    background: white !important;
    border-bottom: 10px solid #1b5e20;
    padding: 0 !important;
    padding-top: 10px !important;
    margin-bottom: 5px !important;
    width: 100%;
    /* margin-left: 6px; */
}
}
</style>

<style>
.b-form-datepicker > button{
  background: none !important;
  border: none !important;
}
</style>
